if (!global._babelPolyfill) {
    require("babel-polyfill");
}

import React from "react";
import { hashHistory } from "react-router";
import { connect } from "react-redux";

import * as actions from "../actions/actions";
import * as actionTypes from "../actions/actionTypes";

import NounProjectPluginLogin from "../components/nounproject-plugin-login";
import NounProjectPluginSignup from "../components/nounproject-plugin-signup";

class NounProjectPluginAuth extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: null
        };
    }

    componentWillReceiveProps(nextProps) {
        let successTypes = [
            actionTypes.LOGIN_SUCCESS,
            actionTypes.SIGNUP_SUCCESS,
            actionTypes.GET_CURRENT_USER_SUCCESS
        ],
            errorTypes = [
                actionTypes.LOGIN_FAILURE,
                actionTypes.SIGNUP_FAILURE
            ];

        if (errorTypes.includes(nextProps.apiResponse.actionType)) {
            this.setState({
                error: nextProps.apiResponse.error
            });
        }

        if (successTypes.includes(nextProps.apiResponse.actionType)) {
            if (
                nextProps.apiResponse.actionType === actionTypes.LOGIN_SUCCESS
            ) {
                this.props.getCurrentUser();
            }

            if (
                nextProps.apiResponse.actionType ===
                actionTypes.GET_CURRENT_USER_SUCCESS
            ) {
                if (nextProps.user.has_premium_account) {
                    hashHistory.push("search");
                } else {
                    hashHistory.push("billing");
                }
            }

            if (
                nextProps.apiResponse.actionType === actionTypes.SIGNUP_SUCCESS
            ) {
                hashHistory.push("billing");
            }
        }
    }

    render() {
        return (
            <div style={{ height: "100%" }}>
                {this.renderAuthForm(this.props.authType)}
            </div>
        );
    }

    renderAuthForm(authType) {
        if (authType === "login") return this.renderLoginForm();
        if (authType === "signup") return this.renderSignupForm();

        console.warn("Invalid authentication type.");
    }

    renderSignupForm(spaceToJoin) {
        return (
            <NounProjectPluginSignup
                signup={this.props.signup}
                error={this.state.error}
            />
        );
    }

    renderLoginForm() {
        return (
            <NounProjectPluginLogin
                login={this.props.login}
                error={this.state.error}
            />
        );
    }
}

NounProjectPluginAuth.propTypes = {
    authType: React.PropTypes.string.isRequired,
    redirectTo: React.PropTypes.string,
    apiResponse: React.PropTypes.object,
    redirectOnSuccess: React.PropTypes.bool,
    user: React.PropTypes.object,
    login: React.PropTypes.func.isRequired,
    signup: React.PropTypes.func.isRequired
};

NounProjectPluginAuth.defaultProps = {
    redirectOnSuccess: true
};

NounProjectPluginAuth.contextTypes = {
    router: React.PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    let apiResponse = state.apiResponse,
        authType,
        redirectTo,
        redirectOnSuccess = ownProps.redirectOnSuccess,
        user = state.user;

    if (ownProps.location) {
        redirectTo = extractQueryStringParam(ownProps.location.search, "next");
    }

    if (ownProps.route) {
        if (ownProps.route.path === "login") authType = "login";
        if (ownProps.route.path === "signup") authType = "signup";
    }

    if (ownProps.authType) authType = ownProps.authType;

    return {
        apiResponse,
        authType,
        redirectTo,
        redirectOnSuccess,
        user
    };
}

function extractQueryStringParam(querystring, param) {
    if (!querystring.includes(`${param}=`)) return null;

    return querystring
        .replace("?", "")
        .split("&")
        .filter(arg => {
            return arg.startsWith(param);
        })[0]
        .split("=")[1];
}

export default connect(mapStateToProps, {
    getCurrentUser: actions.getCurrentUser,
    login: actions.login,
    signup: actions.signup
})(NounProjectPluginAuth);
